/* eslint-disable quotes */
/* eslint-disable dot-notation */
/* eslint-disable no-extra-parens */
/* eslint-disable no-undef */

WB.Popups = WB.Popups || {};
WB.Popups.StoryDirectiveLink = function ($route, $location, PopupDataManager, _Config, _AppData, $timeout, LocationsDataService) {
    return function (scope, element, attr, baseCtrl) {
        scope._Config = _Config;
        scope._AppData = _AppData;
        scope.sourceRoute = 'weather-forecast/now';

        scope.hideNavigation = true;

        var queryValue = $location.search()['s'];
        if(queryValue && queryValue != '')
        {
            try
            {
                scope.hideNavigation = (scope._Config['Platform'][queryValue]['Navigation'].toLowerCase() == 'false') ? false : true;
            }
            catch(err)
            {
                scope.hideNavigation = true;
            }
        }

        scope.$root.$on('$routeUpdate', function (event) {
            var locationSlugName = $location.search()['location'];
            if (locationSlugName && locationSlugName !== '') {
                LocationsDataService.UpdateActiveLocation(locationSlugName).then(function (location) {
                    scope.$root.App.User.ActiveLocation = location;
                    scope.$root.ActiveLocationChanged = true;
                });
            }
        });

        if ($route.current.previousStandardRoute != undefined) {
            scope.sourceRoute = $route.current.previousStandardRoute.locals.name;
        }

    };
};

WB.Popups.StoryDirective = function ($route, $location, PopupDataManager, _Config, _AppData, $timeout, LocationsDataService) {
    return {
        scope: {},
        require: '^wbPopupBase',
        restrict: 'AE',
        refreshAd: '=?',
        link: WB.Popups.StoryDirectiveLink($route, $location, PopupDataManager, _Config, _AppData, $timeout, LocationsDataService),
        template: `<story-popup source-route="sourceRoute" />`
    };
};
WB.Popups.StoryDirective.$inject = ['$route', '$location', 'PopupDataManager', '_Config', '_AppData', '$timeout', 'LocationsDataService'];

WB.App.directive('wbPopupStory', WB.Popups.StoryDirective);
